export const clearImageCache = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('img_')) {
      localStorage.removeItem(key);
    }
  });
};

export const getCacheSize = () => {
  let size = 0;
  for (let key in localStorage) {
    if (localStorage.hasOwnProperty(key)) {
      size += localStorage[key].length + key.length;
    }
  }
  return (size / 1024 / 1024).toFixed(2);
};

export const checkCacheLimit = () => {
  const size = parseFloat(getCacheSize());
  if (size > 8) {
    const keys = Object.keys(localStorage).filter(k => k.startsWith('img_'));
    keys.slice(0, Math.floor(keys.length / 2)).forEach(k => localStorage.removeItem(k));
  }
};
